import type { PdfTemplate } from "../types";

/**
 * Hei Verden PDF-mal (Norsk)
 *
 * En enkel introduksjonsmal som viser grunnleggende struktur
 * for en PDF-mal med tekst, overskrifter og skillelinjer.
 */
export const helloWorld: PdfTemplate = {
  key: "hello-world",
  category: "basic",
  language: "nb_NO",
  name: "Hei Verden",
  description:
    "En enkel introduksjonsmal som viser grunnleggende PDF-struktur med overskrifter, tekst og skillelinjer.",
  badges: ["Grunnleggende", "1 Seksjon", "1 Side"],

  // Standard styling
  fontFamily: "Inter",
  fontSize: 11,
  tableStyleType: "borders",

  sections: [
    {
      name: "Introduksjon",
      scope: "global",
      order: 0,

      // Topptekst med linje
      headerText: "Eksempeldokument",
      headerTextAlign: "left",
      headerShowLine: true,
      headerLineColor: "#e5e5e5",

      // Bunntekst med sidetall
      footerShowNumbers: true,
      footerShowLine: true,
      footerLineColor: "#e5e5e5",

      pages: [
        {
          name: "Velkommen",
          order: 0,
          components: [
            {
              type: "heading",
              order: 0,
              config: { title: "Hei Verden" },
            },
            {
              type: "spacer",
              order: 1,
              config: { height: 20 },
            },
            {
              type: "text",
              order: 2,
              config: {
                content:
                  "Velkommen til din første PDF-mal. Dette dokumentet viser de grunnleggende byggesteinene som er tilgjengelige for å lage profesjonelle PDF-dokumenter.",
                align: "left",
              },
            },
            {
              type: "spacer",
              order: 3,
              config: { height: 30 },
            },
            {
              type: "heading",
              order: 4,
              config: { title: "Kom i gang" },
            },
            {
              type: "text",
              order: 5,
              config: {
                content:
                  "Du kan tilpasse denne malen ved å legge til flere seksjoner, sider og komponenter. Tilgjengelige komponenttyper inkluderer:",
                align: "left",
              },
            },
            {
              type: "spacer",
              order: 6,
              config: { height: 10 },
            },
            {
              type: "text",
              order: 7,
              config: {
                content:
                  "• Overskrifter - For titler og seksjonsoverskrifter\n• Tekst - For avsnitt og beskrivelser\n• Mellomrom - For å kontrollere vertikal avstand\n• Tabeller - For strukturert datavisning\n• Feltverdier - For dynamiske kunde-/flytdata\n• Sideskift - For å kontrollere paginering",
                align: "left",
              },
            },
            {
              type: "spacer",
              order: 8,
              config: { height: 20 },
            },
            {
              type: "text",
              order: 9,
              config: {
                content:
                  "Rediger denne malen for å tilpasse innhold, stil og layout etter dine behov.",
                align: "center",
              },
            },
          ],
        },
      ],
    },
  ],
};
